<template>
  <el-dialog v-dialogDrag title="表达式测试" :visible.sync="dlgVisible" width="500px" append-to-body :modal="false"
    :close-on-click-modal="false" @close="dlgVisible = false">
    <div class="conditionTestDlg" style="margin: 10px">
      <el-form>
        <el-form-item label="表达式"><el-input v-model="condition" placeholder="" size="small"></el-input></el-form-item>
      </el-form>
      <div style="font-size: 14px; line-height: 40px;">
        变量
        <el-button type="text" @click="addParam">+增加一行</el-button>
      </div>
      <el-row>
        <el-col :span="10">
          <div class="listCenter">变量名</div>
        </el-col>
        <el-col :span="10">
          <div class="listCenter">值</div>
        </el-col>
        <el-col :span="2">
          <div class="listCenter">&nbsp;</div>
        </el-col>
      </el-row>
      <el-row v-for="(item, index) in params" :key="index" :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="10">
          <el-input v-model="item.paramName" placeholder="变量名" clearable size="small"></el-input>
        </el-col>
        <el-col :span="10">
          <el-input v-model="item.paramValue" placeholder="变量值" clearable size="small"></el-input>
        </el-col>
        <el-col :span="2">
          <el-button type="text" icon="el-icon-remove" title="删除本行" @click="removeItem(index)"></el-button>
        </el-col>
      </el-row>
      <div>测试结果</div>
      <el-input v-model="testResult" :rows="4" type="textarea" readonly></el-input>
    </div>
    <div slot="footer" style="text-align: right;">
      <el-button type="default" size="small" @click="dlgVisible = false">关闭</el-button>
      <el-button type="primary" size="small" @click="runTest">测试</el-button>
    </div>
  </el-dialog>
</template>

<script>
import flowService from '@/CommonDP/service/flow-service';

const PARAM_ITEM = {
  paramName: "",
  paramValue: ""
};

export default {
  comments: {},
  props: {

  },
  data() {
    return {
      dlgVisible: false,
      condition: "",
      params: [{ ...PARAM_ITEM }],
      testResult: ""
    };
  },

  methods: {
    show(condition) {
      this.condition = condition;
      this.dlgVisible = true;
    },

    addParam() {
      const item = { ...PARAM_ITEM };
      this.params.push(item);
    },

    removeItem(index) {
      this.params.splice(index, 1);
    },

    async runTest() {
      this.testResult = "";
      this.$nextTick();
      const map = {};
      this.params.forEach(p => {
        const paramName = p.paramName.trim();
        if (paramName) {
          map[paramName] = p.paramValue;
        }
      });
      const json = { expr: this.condition, params: map };
      const res = await flowService.testConditionExpr(json);
      this.testResult = res.data || "";
    }
  }
};
</script>

<style lang="scss" scoped>
.listCenter {
  text-align: center;
  line-height: 30px;
}

.conditionTestDlg {
  /deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
}
</style>
